//@ts-check
/**
 * @param {string} selectorCheckAllButtons
 * @param {string} selectorCheckBoxes
 */
window["initCheckAll"] = function (
  selectorCheckAllButtons,
  selectorCheckBoxes,
) {
  /** @type {NodeListOf<HTMLButtonElement>} */
  const checkAllButtons = document.querySelectorAll(selectorCheckAllButtons);
  /** @type {NodeListOf<HTMLInputElement>} */
  const checkBoxes = document.querySelectorAll(selectorCheckBoxes);

  checkAllButtons.forEach((button) => {
    button.addEventListener("click", () => {
      checkBoxes.forEach((cb) => (cb.checked = true));
    });
  });
};
